export const cssSrc = 'https://fonts.googleapis.com/css2?family=Red+Hat+Text:ital,wght@0,300..700;1,300..700&display=swap';
export const appearance = {
  theme: 'minimal',
  variables: {
    fontFamily: '"Red Hat Text", "Open Sans", system-ui, sans-serif',
    fontSizeBase: '14px',
    fontSizeSm: '12px',
    fontWeightNormal: '400',
    colorTextPlaceholder: '#585858',
    borderRadius: '8px',
    colorBackground: 'white',
    colorPrimaryText: 'white',
    spacingGridRow: '24px',
    spacingGridColumn: '24px',
  },
  rules: {
    '.Label': {
      marginBottom: '12px',
      fontSize: '14px',
      color: '#000000',
      fontWeight: '500',
    },
    '.Tab, .Input, .Block': {
      border: '1px solid #ABABAB',
      padding: '13px 12px',
    },
  },
};
